import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import { INTEGRATION_FILTER_CATEGORIES } from '@/data/integrationsMarketplace/integrationsCategories.js'
import styles from './integrationsModal.module.scss'

/**
 * @param {{ categoryId: string, onCategoryChange: (id: string) => void }} props
 */
export default function IntegrationsModalSidebar({ categoryId, onCategoryChange }) {
  return (
    <aside className={styles.sidebar}>
      <Typography component="h3" className={styles.sidebarTitle}>
        Categories
      </Typography>
      <FormGroup className={styles.categoryList}>
        {INTEGRATION_FILTER_CATEGORIES.map((category) => (
          <FormControlLabel
            key={category.id}
            className={styles.categoryItem}
            control={
              <Checkbox
                size="small"
                checked={categoryId === category.id}
                onChange={() => onCategoryChange(category.id)}
              />
            }
            label={category.label}
          />
        ))}
      </FormGroup>
    </aside>
  )
}
